/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Gamepad_DeviceInputs */



/**
* | output |
* | --- |
* | "Gamepad" |
*
* @param {Options_Pedal_Gamepad_DeviceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_gamepad_device = /** @type {((inputs?: Options_Pedal_Gamepad_DeviceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Gamepad_DeviceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gamepad")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gamepad")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gamepad")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Gamepad")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gamepad")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Gamepad")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Gamepad")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Gamepad")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gamepad")
	return /** @type {LocalizedString} */ ("Gamepad")
});